import { render, staticRenderFns } from "./DfRadioGroupField.vue?vue&type=template&id=fc780866&"
import script from "./DfRadioGroupField.vue?vue&type=script&lang=js&"
export * from "./DfRadioGroupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports